// src/tooltip/tooltip-context.ts
import { createContext } from "react";
var TooltipContext = createContext(
  void 0
);

export {
  TooltipContext
};
